// extracted by mini-css-extract-plugin
module.exports = {"ExtraPhoto":"extraPhoto_ExtraPhoto__8KbVl","thumb":"extraPhoto_thumb__pumjX","img":"extraPhoto_img__30Wii","txt":"extraPhoto_txt__F1B_J"};